import { render, staticRenderFns } from "./ShipperGroupBulkUpdate.vue?vue&type=template&id=df11ed52"
import script from "./ShipperGroupBulkUpdate.vue?vue&type=script&lang=js"
export * from "./ShipperGroupBulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./ShipperGroupBulkUpdate.vue?vue&type=style&index=0&id=df11ed52&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports